import React from 'react';
import type { InsightEvent } from '../types/insights';
type InsightLogPanelProps = {
  events: InsightEvent[];
  onClear: () => void;
};
const LABELS: Record<InsightEvent['type'], string> = {
  intro_completed: 'Intro completed',
  case_replayed: 'Case replayed',
  case_shown: 'Case shown',
  case_started: 'Case started',
  drug_selected: 'Current FSH',
  dose_selected: 'Current dose',
  response_run: 'Response run',
  reveal_clicked: 'Revealed REKOVELLE',
  choice_changed_after_reveal: 'Changed after reveal',
  next_patient: 'Tried another patient'
};
export function InsightLogPanel({
  events,
  onClear
}: InsightLogPanelProps) {
  const exportJson = () => {
    const blob = new Blob([JSON.stringify(events, null, 2)], {
      type: 'application/json'
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'rekovelle-simulator-insights.json';
    a.click();
    URL.revokeObjectURL(url);
  };
  return <section className="mt-8 rounded-2xl border border-rule bg-white" aria-label="Insight log" data-id="element-137" data-mp="2g37xege1boox">
      <header className="flex items-center justify-between border-b border-rule px-5 py-3 md:px-6" data-id="element-138" data-mp="2l1rk4j0gd4ic">
        <span className="font-mono text-[11px] tracking-[0.16em] text-ink" data-id="element-139" data-mp="26deknc25p3j3">INSIGHT LOG · {events.length} EVENTS</span>
        <span className="flex gap-4 text-xs" data-id="element-140" data-mp="2bbg43y3hv4v3">
          <button type="button" onClick={exportJson} className="text-graphite transition-colors duration-150 hover:text-ink" data-id="element-141" data-mp="2baep5ijcxy83">
            Export JSON
          </button>
          <button type="button" onClick={onClear} className="text-graphite transition-colors duration-150 hover:text-ink" data-id="element-142" data-mp="22cl08snxa6uy">
            Clear
          </button>
        </span>
      </header>
      {events.length === 0 ? <p className="px-6 py-6 text-sm text-graphite" data-id="element-143" data-mp="1sdlyzv5hldhz">No interactions captured yet.</p> : <div className="max-h-72 overflow-y-auto" data-id="element-144" data-mp="3ht3804jbo4kf">
          <table className="w-full text-left text-xs" data-id="element-145" data-mp="3mrwlvy2itxl4">
            <thead className="sticky top-0 bg-wash font-mono text-[10px] tracking-[0.14em] text-graphite/70" data-id="element-146" data-mp="3mpaga3z6xs5j">
              <tr data-id="element-147" data-mp="3l7v148kog83g">
                <th className="px-6 py-2 font-normal" data-id="element-148" data-mp="3gbea96m3ffmo">TIME</th>
                <th className="px-3 py-2 font-normal" data-id="element-149" data-mp="3g9tjzt6taium">PATIENT</th>
                <th className="px-3 py-2 font-normal" data-id="element-150" data-mp="3bd31kz7jbb61">EVENT</th>
                <th className="px-3 py-2 font-normal" data-id="element-151" data-mp="37apx0e4ixjau">DETAIL</th>
              </tr>
            </thead>
            <tbody className="font-mono" data-id="element-152" data-mp="7v1n477kb26w">
              {[...events].reverse().map(e => <tr key={e.id} className="border-t border-rule" data-id="element-153" data-mp="2wi166syxqej">
                  <td className="px-6 py-2 text-graphite" data-id="element-154" data-mp="2x03nl6850uw">{new Date(e.at).toLocaleTimeString()}</td>
                  <td className="px-3 py-2" data-id="element-155" data-mp="3u92ucc8c6iqo">PT-{e.patientId}</td>
                  <td className="px-3 py-2 font-sans text-ink" data-id="element-156" data-mp="3q89b3w5u9s44">{LABELS[e.type]}</td>
                  <td className="px-3 py-2 text-graphite" data-id="element-157" data-mp="qmc9cb2ceqsg">
                    {Object.entries(e.data).map(([k, v]) => `${k}: ${v}`).join(' · ')}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>}
    </section>;
}